// import { fabric } from "fabric";
import { IBrushType } from "../../../common/enums/PenEnums";
import { drawPath, drawPath_arr } from "../../../common/util/DrawCurves";
import { FabricPath } from "../../PseudoFabric";
export function createFabricPath(stroke, cache, ncodeToPdfXyFn, opacityConverter = undefined) {
    const { color, brushType, key } = stroke;
    const pathData = createPathData(stroke, ncodeToPdfXyFn);
    let opacity = 0;
    switch (brushType) {
        case IBrushType.PEN:
            opacity = 1;
            break;
        case IBrushType.MARKER:
            opacity = 0.3;
            break;
        case IBrushType.ERASER:
            opacity = 0;
            break;
        case IBrushType.ERASED:
            opacity = 0;
            break;
        default:
            opacity = 1;
            break;
    }
    // TODO: 충남교육청, NEP에서는 아래를 쓸 것, 어떻게 해야하지?
    // const c = color === "#000000" ? NAVYBLUE_STROKE_COLOR : color;
    const c = color;
    if (opacityConverter) {
        opacity = opacityConverter(stroke, opacity);
    }
    const pathOption = {
        // stroke: color, //"rgba(0,0,0,255)"
        fill: c,
        color: c,
        opacity,
        // strokeWidth: 10,
        originX: 'left',
        originY: 'top',
        selectable: false,
        data: { isStroke: true, color: c, stroke, opacity },
        evented: true,
        key: key,
        objectCaching: cache,
    };
    // const path = new fabric.Path(pathData, pathOption) as IExtendedPathType;
    const path = new FabricPath(pathData, pathOption);
    path.neoStroke = stroke;
    return path;
}
export function createPathData(stroke, ncodeToPdfXyFn) {
    const { dotArray, brushType, thickness } = stroke;
    // const pointArray = [];
    // dotArray.forEach((dot) => {
    //   const pt = ncodeToPdfXyFn(dot);
    //   pointArray.push(pt);
    // });
    const pointArray = dotArray.map((dot) => ncodeToPdfXyFn(dot));
    let strokeThickness = thickness * 4;
    switch (brushType) {
        case IBrushType.MARKER:
            strokeThickness *= 5;
            break;
        default: break;
    }
    const pathData = drawPath(pointArray, strokeThickness);
    return pathData;
}
export function createPathData_arr(stroke, ncodeToPdfXyFn) {
    const { dotArray, brushType, thickness } = stroke;
    const pointArray = [];
    dotArray.forEach((dot) => {
        const pt = ncodeToPdfXyFn(dot);
        pointArray.push(pt);
    });
    let strokeThickness = thickness * 4;
    switch (brushType) {
        case IBrushType.MARKER:
            strokeThickness *= 5;
            break;
        default: break;
    }
    const pathData_arr = drawPath_arr(pointArray, strokeThickness);
    return pathData_arr;
}
export function timeOut(n) {
    return new Promise(resolve => { setTimeout(() => { resolve(true); }, n); });
}
//# sourceMappingURL=static_functions.js.map